import React from 'react';
import {
    Form,
} from 'react-bootstrap';

export default function FormGroupModoVisualizacao(props) {
    const onChange = (newFilter) => {
        // console.log({FiltersMenuChangeFilter: newFilter});
        props.onChange(newFilter);
    }

    return (
        <Form.Group className={props.isMobile ? "" : "mt-3"}>
            <Form.Label>
                Modo de visualização
            </Form.Label>
            <Form.Select
                className="modo_visualizacao"
                onChange={(e) => {
                    onChange({modo: e.target.value});
                }}
                value={props.value}
            >
                <option key="panorama" value="panorama">Panorama</option>
                <option key="mapa" value="mapa">Mapa</option>
                <option key="listagem" value="listagem">Cadastros</option>
            </Form.Select>
        </Form.Group>
    );
}
